module.exports = __webpack_public_path__ + "static/media/plus-icon.8f69366b.svg";